<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          @if (isNew) {
            <astral-select [control]="form.controls['configurationLevel']" [itemsSource]="levelSelection"></astral-select>
          }
        </astral-layout-group>
      </section>
      @if (!isNew) {
        <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
          <section class="astral-section-surface astral-section-surface--subtle astral-stack-m">
            <h5>{{ accessSelectionHeader | translate }}</h5>
            <div class="astral-stack-s">
              @for (item of selectedTargets; track item; let i = $index) {
                <div class="location-access-row">
                  <span>{{ item.caption }}</span>
                  <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeAccess(i)"></astral-button>
                </div>
              }
            </div>
            <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
              <app-autocomplete class="astral-layout-item" #memSel [control]="targetSelectionControl" [itemsSource]="accessSelection"></app-autocomplete>
              <div class="astral-form-adjacent-action">
                <astral-button variant="primary" type="button" icon="plus" labelKey="ADD_BTN" (click)="addAccess()"></astral-button>
              </div>
            </astral-layout-group>
          </section>
          <section class="astral-section-surface astral-section-surface--subtle astral-stack-m">
            <h5>{{ 'LOCATION_ACCESS.MEMBERS' | translate }}</h5>
            <div class="astral-stack-s">
              @for (item of selectedMembers; track item; let i = $index) {
                <div class="location-access-row">
                  <span>{{ item.caption }}</span>
                  <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeMember(i)"></astral-button>
                </div>
              }
            </div>
            <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
              <app-autocomplete class="astral-layout-item" #memSel [control]="memberSelectionControl" [itemsSource]="memberSelection"></app-autocomplete>
              <div class="astral-form-adjacent-action">
                <astral-button variant="primary" type="button" icon="plus" labelKey="ADD_BTN" (click)="addMember()"></astral-button>
              </div>
            </astral-layout-group>
          </section>
        </astral-layout-group>
      }
    </form>
  }
</section>
